<template>
  <flex
    class="btn"
    align="center"
    justify="center"
    @click.native="$emit('click')"
  >
    <slot />
  </flex>
</template>

<script>
import Flex from '@/components/Flex.vue'

export default {
  name: 'Btn',

  components: {
    Flex
  }
}
</script>

<style lang="sass" scoped>
.btn
  width: 58px
  height: 14px
  color: #9b9b9b
  background: #cdcdcd
  transition: all 150ms
  &:hover
    z-index: 1
    background: #fff
    box-shadow: 0 0 0 1px #9b9b9b
</style>
